export interface StorageProvider {
    key: 'gcs' | 'aws' | 'cloudflare';
    name: string;
    img: string;
    imgWidth: number;
    imgHeight: number;
    modal: string;
}

export const allProviders: StorageProvider[] = [
    {
        key: 'gcs',
        name: 'Google Cloud',
        img: 'https://d1vyenbk43iobe.cloudfront.net/application/images/google_new.png',
        imgWidth: 156,
        imgHeight: 33,
        modal: 'showGcsModal',
    },
    {
        key: 'aws',
        name: 'Amazon S3',
        img: 'https://d1vyenbk43iobe.cloudfront.net/application/images/aws_new.png',
        imgWidth: 54,
        imgHeight: 36,
        modal: 'showAwsModal',
    },
    {
        key: 'cloudflare',
        name: 'Cloudflare R2',
        img: 'https://d1vyenbk43iobe.cloudfront.net/application/images/cloudflare.png',
        imgWidth: 96,
        imgHeight: 36,
        modal: 'showCloudflareModal',
    },
];
